/* global maplibregl */

Apt.fn.extend('maps', {}, {
	/**
	 * Create new instance
	 *
	 * @param {$} target
	 * @param {Object} options
	 * @param {Function} fn
	 */
	create(target, options, fn) {
		const scope = this;

		scope.$parent = $(target);

		const $container = $('<div class="map-container"/>');

		scope.$parent.append($container);

		if (! options.center || ! scope.validate(options.center)) {
			options.center = scope.default.center;
		}

		fn({
			$container: $container,
			active: true,
			bounced: [],
			events: [],
			layers: [],
			sources: [],
			map: new maplibregl.Map(Object.assign({
				aroundCenter: false,
				attributionControl: false,
				bearingSnap: 35,
				container: $container[0],
				keyboard: false,
				maxPitch: 65,
				maxZoom: 18.4,
				minZoom: 3,
				pitchWithRotate: false,
				style: scope.getStyling(scope.conf.style),
				touchPitch: false,
				zoom: 5
			}, options))
		});
	},

	/**
	 * Purge instance
	 */
	purge() {
		const scope = this;

		$.fetch.abort('map');

		if (scope.uid) {
			$.events.reset(scope.uid);
		}

		if (scope.inspect) {
			scope.inspect.$destroy();

			scope.inspect = null;
		}

		if (scope.model) {
			scope.model.$destroy();

			scope.model = null;
		}

		if (scope.map) {
			scope.map.remove();

			scope.$public.map = scope.map = null;
		}

		if (scope.$parent) {
			scope.$parent.empty();
		}

		scope.$parent = null;
	}
});